import React, { JSX } from "react";

export type PopoverContentProps = {
  className?: string;
  position?: PopoverContentPosition;
  children: React.ReactElement<JSX.Element> | React.ReactElement<JSX.Element>[];
};

export type PopoverContentPosition = {
  default?: Position;
  top?: Position;
  bottom?: Position;
  left?: Position;
  right?: Position;
};

export type Position = {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
};

export default function PopoverContent({ children }: PopoverContentProps): JSX.Element {
  return <>{children}</>;
}
